import { create } from "zustand";
const useTopbarLayoutStore = create((set) => ({
    setCenterItems: (centerItems) => set({ centerItems }),
    setCurrentProduct: (currentProduct) => set({ currentProduct }),
    setShowTimeEditIcon: (showTimeEditIcon) => set({ showTimeEditIcon })
}));
export default useTopbarLayoutStore;
